<template>
  <form @submit.prevent="">
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="custom-header">
          <div class="row">
            <div class="col-md-11">
              <h4 class="modal-title">
                {{ title }}
              </h4>
            </div>
            <div class="col-md-1">
              <a href="#" class="custom-close" @click="close">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
      <template #body>
        <div class="row">
          <div class="col">
            <p>When searching for a location, only those that are designated as Corporate, Center, or Shop will be returned.</p>
          </div>
        </div>
        <div class="row custom-body">
          <div class="col">
            <Multiselect
              ref="searchLocation"
              v-model="foundLocation"
              class="form-control custom-multiselect"
              placeholder="type to search"
              :close-on-select="true"
              :filter-results="false"
              :min-chars="1"
              :resolve-on-load="false"
              :delay="500"
              :searchable="true"
              :open-direction="'bottom'"
              :options="
                async (query) => {
                  return await fetchLocations(query)
                }
              "
              label="firmName"
              value-prop="firm"
              @select="selectedLocation"
            />
          </div>
          <div class="col"></div>
        </div>
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col"></div>
          <div class="col custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
            <button v-show="isSave" class="btn btn-danger ms-2" @click="save(false)">Save</button>
          </div>
        </div>
      </template>
    </z-dialog>
  </form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { wasabiStore } from '@/stores/wasabi'
import { locationStore } from '@/stores/location'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import Multiselect from '@vueform/multiselect'
export default {
  name: 'DialogAdd',
  components: {
    ZDialog,
    Multiselect
  },
  props: {
    modelValue: Object,
    showFirm: Object
  },
  emits: ['closing', 'saved'],
  data() {
    return {
      modalSize: 'modal-md',
      isSave: false,
      foundLocation: null
    }
  },
  computed: {
    ...mapState(wasabiStore, ['account']),
    ...mapState(locationStore, ['foundLocations']),
    isVisible() {
      return this.modelValue !== null
    },
    title() {
      let _title = 'Add Wasabi Account'
      return _title
    }
  },
  methods: {
    ...mapActions(wasabiStore, ['setAccount', 'createAccount']),
    ...mapActions(locationStore, ['searchLocations', 'resetFoundLocations']),
    close() {
      this.resetFoundLocations()
      this.isSave = false
      this.$emit('closing')
    },
    async fetchLocations(query) {
      let search = {
        search: query,
        type: 5,
        firmType: null,
        firm: 1
      }
      return await this.searchLocations(search)
    },
    selectedLocation() {
      this.$nextTick(() => {
        let found = this.foundLocations.find((x) => parseInt(x.firm) === parseInt(this.foundLocation))
        if (found) {
          this.isSave = true
          console.log('Found Location', found)
        }
      })
    },
    save() {
      if (this.isSave) {
        this.isSave = false
        console.log('Save New Account', this.foundLocation)
        if (this.foundLocation) {
          this.createAccount(this.foundLocation)
        }
        this.$emit('saved')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.hostWrapper {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: auto;
  height: 600px;
}
.custom-header-label {
  font-weight: 600;
}
.custom-body {
  min-height: 300px;
}
</style>
